import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'ContentEndLevelPopupLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '05010f98-1625-496a-859f-8d4933433706',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '7e821abc-d372-445a-97b7-718c735ea6f1',
      type: 'Container',
      name: 'sideContainer',
      nameSpace: '',
      className: '',
      x: 300,
      y: -248,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '5cc0e50b-3468-459b-9786-5a36aeecfa5f',
      type: 'Sprite',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 0.942006
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reminder_window',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '0d02c613-ef36-4e94-86a4-e7245b6090dc',
      type: 'Sprite',
      name: 'headerBg',
      nameSpace: '',
      className: '',
      x: -4,
      y: -251,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '6b8770b9-2782-4329-8551-7b5c5ee148f9',
      type: 'Text',
      name: 'headerText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -261,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassPremiumActivate',
      localize: true,
      maxWidth: 433,
      maxHeight: 121,
      maxFontSize: 49,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#933019',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '3b9dbbb0-b7f5-4938-89c7-e9582233102a',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 443,
      y: -242,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_close',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '6635b2ef-0304-4c20-bb80-a1e9f6eea59f',
      type: 'Sprite',
      name: 'buttonContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 247,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blank',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '280699fb-d598-46e8-9ddd-c56b604573e7',
      type: 'Container',
      name: 'mainContent',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'ebde1d42-5666-4498-9875-b927224605c5',
      type: 'Container',
      name: 'TimerContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 58,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '0d02c613-ef36-4e94-86a4-e7245b6090dc',
      data: ''
    },
    {
      id: 'f4c22154-70cc-4c5a-b9b2-a75459e6c891',
      type: 'Sprite',
      name: 'purchaseButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '6635b2ef-0304-4c20-bb80-a1e9f6eea59f',
      data: ''
    },
    {
      id: '013a20b6-2e6b-49b0-9c24-1a3582e68c3e',
      type: 'Text',
      name: 'desc1',
      nameSpace: '',
      className: '',
      x: 0,
      y: -150,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassReminderDescription1',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 1,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#933019',
        stroke: 'white',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 602,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: '7ecf4c87-a54c-4311-85b8-961f6aede336',
      type: 'Text',
      name: 'desc2',
      nameSpace: '',
      className: '',
      x: 0,
      y: -117,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassReminderDescription2',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 1,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#933019',
        stroke: 'white',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 602,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: 'd72d68bf-94fe-4349-a473-d24fd049ee98',
      type: 'Text',
      name: 'desc3',
      nameSpace: '',
      className: '',
      x: 0,
      y: 143,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassReminderDescription3',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 1,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#933019',
        stroke: 'white',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 602,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: '50bcd8d0-3812-42af-bb97-0264aa22db08',
      type: 'Sprite',
      name: 'ArrowNext',
      nameSpace: '',
      className: '',
      x: 379,
      y: -11,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'arrow_next',
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: '2995fece-1ff1-4f4e-afc6-7b32d62a8883',
      type: 'Sprite',
      name: 'ArrowPrevious',
      nameSpace: '',
      className: '',
      x: -402,
      y: -11,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'arrow_previous',
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: 'f0102b95-5491-41e0-b386-43e5c5e703d4',
      type: 'Sprite',
      name: 'RewardContainer',
      nameSpace: '',
      className: '',
      x: 6,
      y: 13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 0.951923
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reward_frame_shadow',
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: '4e14a314-2295-42c1-a145-64944e2e569d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'offer_icon_timer',
      parent: 'ebde1d42-5666-4498-9875-b927224605c5',
      data: ''
    },
    {
      id: '7138f72a-704d-43af-a646-d161d60b51bc',
      type: 'Text',
      name: 'timeText',
      nameSpace: '',
      className: '',
      x: 15,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '14 days',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#692012',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ebde1d42-5666-4498-9875-b927224605c5',
      data: ''
    },
    {
      id: '48169862-db2a-4458-8134-5c976489402b',
      type: 'Text',
      name: 'purchaseText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Ok',
      localize: true,
      maxWidth: 226,
      maxHeight: 71,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#074829',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f4c22154-70cc-4c5a-b9b2-a75459e6c891',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassPurchaseReminder {
  static raw = raw;
  root: PIXI.Container
  sideContainer: PIXI.Container
  bg: PIXI.Sprite
  headerBg: PIXI.Sprite
  TimerContainer: PIXI.Container
  timeText: PIXI.Text
  headerText: PIXI.Text
  closeButton: PIXI.Sprite
  buttonContainer: PIXI.Sprite
  purchaseButton: PIXI.Sprite
  purchaseText: PIXI.Text
  mainContent: PIXI.Container
  desc1: PIXI.Text
  desc2: PIXI.Text
  desc3: PIXI.Text
  RewardContainer: PIXI.Sprite
  ArrowNext: PIXI.Sprite
  ArrowPrevious: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
